import moment from 'moment';
import * as _ from 'lodash';
import * as utils from 'common/utils';
import { history } from 'common/helpers';
import { defaultChartSettings } from 'common/charts/constants';
import * as hierarchyUtils from '../utils/assetHierarchyUtils';

export function getChartSettingsFromSession() {
  const chartSettings = sessionStorage.getItem('chartSettings');
  return chartSettings ? JSON.parse(chartSettings) : {};
}

export function createChartsViewSessionUtils({ getState, getProps }) {
  const updateUrlQueryString = (timestamp = null) => {
    const props = getProps();
    const state = getState();
    const urlParams = new URLSearchParams(props.location.search);
    const settings = Object.fromEntries(urlParams);

    if (timestamp !== null && timestamp !== undefined) {
      let ts = timestamp;
      if (typeof ts === 'number' && ts < 1e12) ts *= 1000;
      try {
        settings.timestamp = utils.formatTimestampForAPI(ts);
      } catch (e) {
        // Ignore invalid timestamps and keep existing value if any
      }
    }
    const { chartType, amp_type, measurement_type, feature, bin_nos } = state;
    const nextSettings = {
      timestamp: settings.timestamp,
      chartType,
      amp_type,
      measurement_type,
      feature
    };
    if (!_.isEmpty(bin_nos)) {
      nextSettings.bin_nos = bin_nos.join(',');
    }
    const queryString = utils.generateQueryString(nextSettings);
    const pathname = props.location.pathname;
    history.replace({
      pathname,
      search: queryString
    });
  };

  const setChartSettingsInSession = () => {
    const { tag, chartType, amp_type, measurement_type, feature, waterfallXUnit } = getState();
    const chartSettings = getChartSettingsFromSession();
    chartSettings[tag.structure_type] = { amp_type, feature, measurement_type, chartType, waterfallXUnit };
    sessionStorage.setItem('chartSettings', JSON.stringify(chartSettings));
    updateUrlQueryString();
  };

  const setCalendarInSession = () => {
    const { days, customDayFrom, customDayTo } = getState();
    const chartSettings = getChartSettingsFromSession();
    chartSettings.calendar = { days: days || null, customDayFrom, customDayTo };
    sessionStorage.setItem('chartSettings', JSON.stringify(chartSettings));
  };

  const setBinNosInSession = () => {
    const { bin_nos } = getState();
    const { machine_id } = hierarchyUtils.getSelectedPathFromBreadcrumb(getProps().breadcrumb);
    const chartSettings = getChartSettingsFromSession();
    if (!chartSettings.bin_nos) chartSettings.bin_nos = {};
    chartSettings.bin_nos[machine_id] = bin_nos;
    sessionStorage.setItem('chartSettings', JSON.stringify(chartSettings));
    updateUrlQueryString();
  };

  const setTimeStampInSession = (timestamp) => {
    const { machine_id } = hierarchyUtils.getSelectedPathFromBreadcrumb(getProps().breadcrumb);
    const chartSettings = getChartSettingsFromSession();
    if (!chartSettings.timestamp) chartSettings.timestamp = {};
    chartSettings.timestamp[machine_id] = timestamp;
    sessionStorage.setItem('chartSettings', JSON.stringify(chartSettings));
    updateUrlQueryString(timestamp);
  };

  const getChartSettingsFromUrl = (str_type) => {
    const props = getProps();
    const { machine_id } = hierarchyUtils.getSelectedPathFromBreadcrumb(props.breadcrumb);
    const urlParams = new URLSearchParams(props.searchParams ? props.searchParams : props.location.search);
    const settings = Object.fromEntries(urlParams);
    const oldSettings = getChartSettingsFromSession();
    if (settings.timestamp) {
      const currDate = new Date();
      let days = 30;
      if (oldSettings.calendar && oldSettings.calendar.days && !Number.isNaN(oldSettings.calendar.days)) {
        days = parseInt(oldSettings.calendar.days, 10);
      }
      const fromDate = new Date(moment().subtract(days, 'days').toString());
      const givenDate = new Date(moment(settings.timestamp).toString());
      if (givenDate.getTime() > fromDate.getTime() && givenDate.getTime() <= currDate.getTime()) {
        settings.calendar = {
          days,
          customDayFrom: null,
          customDayTo: null
        };
      } else {
        settings.calendar = {
          days: 'custom',
          customDayFrom: new Date(moment(settings.timestamp).subtract(10, 'days').toString()),
          customDayTo: new Date(moment.min(moment(), moment(settings.timestamp).add(4, 'days')).toString())
        };
      }
    }
    Object.keys(settings).forEach((key) => {
      if (key === 'timestamp') {
        if (machine_id) settings[key] = { [machine_id]: settings[key] };
        else delete settings[key];
      } else if (key === 'amp_type' || key === 'feature' || key === 'measurement_type' || key === 'chartType') {
        if (!str_type) return;
        settings[str_type] = {
          ...(settings[str_type] || defaultChartSettings[str_type]),
          [key]: key === 'measurement_type' ? parseInt(settings[key], 10) : settings[key]
        };
        delete settings[key];
      } else if (key === 'bin_nos' && machine_id) {
        settings[key] = { [machine_id]: settings[key].split(',').map(bin => parseInt(bin, 10)) };
      }
    });
    return settings;
  };

  const setSessionStorageFromUrl = (str_type) => {
    const chartSettings = {
      ...getChartSettingsFromSession(),
      ...getChartSettingsFromUrl(str_type)
    };
    if (!_.isEmpty(chartSettings)) sessionStorage.setItem('chartSettings', JSON.stringify(chartSettings));
  };

  return {
    getChartSettingsFromSession,
    setChartSettingsInSession,
    setCalendarInSession,
    setBinNosInSession,
    setTimeStampInSession,
    updateUrlQueryString,
    getChartSettingsFromUrl,
    setSessionStorageFromUrl
  };
}
